import { __decorate, __metadata } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
let StringMatchServiceImpl = class StringMatchServiceImpl {
    constructor() { }
    escapeRegExp(text) {
        return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    match(str, keyword) {
        const escapedKeyword = this.escapeRegExp(keyword);
        return new RegExp(escapedKeyword, 'i').test(str);
    }
    highlight(str, keyword) {
        const escapedKeyword = this.escapeRegExp(keyword);
        return str.replace(new RegExp(`(${escapedKeyword})`, 'i'), '<span class="highlight">$1</span>');
    }
};
StringMatchServiceImpl = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], StringMatchServiceImpl);
export { StringMatchServiceImpl };
